import React from 'react'; 

import { AppLinkButton } from 'components';
import { A, BodyMediumText, BodyLargeText, Card, Column, Caption, H2, H3, Section, SectionHeader, Tabs } from 'playful-ui';

import campImg from '../assets/sq/1camp_square.jpg';
import robotiImg from '../assets/sq/2roboti_sq.jpg';
import tri from '../assets/sq/3.jpg';
import na_podu from '../assets/sq/4na_podu_sq.jpg';
import screwImg from '../assets/sq/5screw_square.jpg';
import qedImg from '../assets/sq/6qed_sq.jpg'

import { Module1, Module2, Module3, Master, WorkshopsForm } from '../components';

const tabNames = ['MODUL 1', 'MODUL 2', 'MODUL 3', 'MASTER'];
const modules = [
  <Module1 />,
  <Module2 />,
  <Module3 />,
  <Master />,
]

export class WorkshopsPage extends React.Component {
  static route = '/workshops';

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    }
  }

  handleClick = i => {
    this.setState({ activeIndex: i });
  }

  render() {
    return (
      <React.Fragment>
        <Section>
          <Card
            className="silver"
            images={[campImg, robotiImg, tri, na_podu, screwImg, qedImg]}
          >
            <Caption>STEMI LAB</Caption>
            <H3>Program</H3>
            <BodyMediumText>
              Program je organiziran u više modula, koji se međusobno nadopunjuju. Kreće se od osnova
              prema naprednijem sadržaju. Radi se u grupi od 12 polaznika kako bi radionice bile
              optimalne za kreativnu atmosferu, projektno orijentiran timski rad i maksimalnu
              posvećenost edukatora svakom polazniku. Predznanje nije potrebno,
              samo radoznalost i motivacija za stvaranjem. Svi mladi istraživači stariji od 12
              godina su dobrodošli.
            </BodyMediumText>
            <AppLinkButton style={{ marginTop: '24px' }} to='/workshops#prijave'>
              PRIJAVI SE
            </AppLinkButton>
          </Card>
        </Section>
        <Section className="textual">
          <Column className="h-center">
            <SectionHeader index={4}/>
            <H2 style={{ marginBottom: '48px' }} >Prijavi se na jedan od modula</H2>
            <Tabs 
              tabNames={tabNames}
              onClick={this.handleClick}
              activeIndex={this.state.activeIndex}
            />
            {modules[this.state.activeIndex]}
          </Column>
        </Section>
        <Section className="textual">
          <Column className="h-center">
            <H3>Cijena modula je 400kn&nbsp;
              <span style={{ lineHeight: '1.39', opacity: '0.3' }}>
                (<strike>560kn</strike>)
              </span>
            </H3>
            <BodyLargeText>8 školskih sati u sklopu 4 radionice robotike.</BodyLargeText>
            <AppLinkButton style={{ marginTop: '24px' }} to="/workshops#prijave">PRIJAVI SE</AppLinkButton>
          </Column>
        </Section>
        <Section id="prijave" className="textual">
          <BodyLargeText>
            Prijaviti se možete na mail <A href='mailto:sales@stemi.education'>sales@stemi.education</A>
            &nbsp;ili putem sljedećeg obrasca:
          </BodyLargeText>
          <WorkshopsForm />
        </Section>
      </React.Fragment>
    );
  }
}
